export default {
  active: 'Active',
  prospective: 'Prospective',
  deleted: 'Deleted',
  removed: 'Removed',
};
